import { Swiper } from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import afterPaint from '../../../js/__utils/afterPaint';

const sliders = document.querySelectorAll('.block-hero-display .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			// direction: 'vertical',
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			// centeredSlides: true,
			modules: [Autoplay, Pagination, EffectFade],
			speed: 1000,
			autoplay: {
				delay: 5000,
			},
		};

		afterPaint(() => {
			new Swiper(slider, settings);
		});
	});
}
